import styled from '@emotion/styled';
import { Link } from 'react-router-dom';

import { fontFamily, fontSize, fontWeight } from 'ms-styles/base';
import { colors } from 'ms-styles/colors';
import { multilineTextOverflow } from 'ms-utils/emotion';

const CURRICULUM_ITEM_MIN_WIDTH = 380;
const SYLLABUS_ITEM_WIDTH = 268;

export const CurriculumItem = styled(Link)({
  paddingTop: 4,
  paddingBottom: 4,
  minWidth: CURRICULUM_ITEM_MIN_WIDTH,
  width: '100%',
  height: 52,
  display: 'flex',
  fontFamily: fontFamily.body,
  alignItems: 'center',
  color: 'inherit',
  textDecoration: 'none',
});

export const SyllabusItem = styled(Link)({
  background: colors.almond50,
  padding: 12,
  borderRadius: 12,
  width: SYLLABUS_ITEM_WIDTH,
  height: 168,
  display: 'flex',
  fontFamily: fontFamily.body,
  alignItems: 'center',
  color: 'inherit',
  textDecoration: 'none',
});

export const Title = styled.div<{ oneLine: boolean }>(
  {
    fontSize: '18px',
    lineHeight: '24px',
    fontWeight: fontWeight.semibold,
    marginBottom: 8,
    ...multilineTextOverflow(3),
  },
  ({ oneLine }) =>
    oneLine && {
      ...multilineTextOverflow(1),
    },
);

export const Subtitle = styled.div({
  fontSize: fontSize.small,
  color: colors.shuttleGray,
});

export const CurriculumGridWrapper = styled.div({
  display: 'grid',
  gridTemplateColumns: `repeat(auto-fill,minmax(${CURRICULUM_ITEM_MIN_WIDTH}px, 1fr))`,
  justifyItems: 'center',
  columnGap: 128,
  rowGap: 32,
});

export const SyllabusGridWrapper = styled.div({
  display: 'grid',
  gridTemplateColumns: `repeat(auto-fill,minmax(${SYLLABUS_ITEM_WIDTH}px, 1fr))`,
  justifyItems: 'center',
  gridGap: 24,
});

const DETAILS_PADDING = 12;
export const CurriculumDetails = styled.div({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-between',
  height: '100%',
  paddingLeft: DETAILS_PADDING,
  paddingRight: DETAILS_PADDING,
  overflow: 'hidden',
});

export const SyllabusDetails = styled.div({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-between',
  paddingLeft: DETAILS_PADDING,
  paddingRight: DETAILS_PADDING,
});

export const SyllabusThumbnail = styled.img({
  height: '100%',
  borderRadius: `4px 12px 12px 4px`,
});

export const CurriculumThumbnailWrapper = styled.div({
  height: '100%',
  width: 50,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-start',
  flexShrink: 0,
  flexGrow: 0,
});

export const CurriculumThumbnail = styled.img();

export const ThumbnailWrapper = styled.div({
  width: 90,
  height: 140,
  flexBasis: 90,
  flexShrink: 0,
  borderRadius: `4px 12px 12px 4px`,
  background: 'white',
  overflow: 'hidden',
  boxShadow: '0px 8.75px 49px 0px #21374D66',
});
